// extracted by mini-css-extract-plugin
export default {"fieldset":"comment_fieldset__MPTpR"};